import { useEffect, useState } from 'react';
import accountApis, { IGetEmployeesParams } from '../../../../services/accountApis';
import { AxiosResponse } from 'axios';
import { IGetEmployeesResponse } from '../types';

export const PAGE_SIZE_EMPLOYEES = 10;
const initData = {
  page: 1,
  roleName: '',
  keySearch: '',
};

const useGetEmployees = (isLazy = false) => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState<IGetEmployeesResponse>();
  const [loading, setLoading] = useState(false);

  const getEmployees = async (params: IGetEmployeesParams) => {
    const paramsSubmit = { ...params, size: PAGE_SIZE_EMPLOYEES };
    setLoading(true);
    try {
      const response: AxiosResponse<{ data: IGetEmployeesResponse }> =
        await accountApis.getEmployees(paramsSubmit);
      setData(response.data.data);
    } catch (error) {
      setData(undefined);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isLazy) {
      getEmployees(initData);
    }
    return () => {
      setData(undefined);
      setPage(1);
    };
  }, [isLazy]);

  return { page, setPage, data, getEmployees, loading };
};

export default useGetEmployees;
